import * as React from 'react';
import * as S from './styles';
import { IListProps } from './types';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'store/types';
import { Review } from '../../../state/types';
import { getRatingRecommended } from '../../utils'

const List: React.FC<IListProps> = (props) => {
    const [reviewsList, setReviewsList] = React.useState<Review[]|undefined>(undefined);

    const {
        reviewsFiltered
    } = useSelector((rootState: RootState) => {
        return {
            reviewsFiltered: rootState.reviews.reviewsFiltered,
        };
    }, shallowEqual);

    React.useEffect(() => {
        if (reviewsFiltered?.reviews) {
            if (reviewsFiltered?.lenght===0) setReviewsList([]);
            else if (reviewsFiltered?.start===0) setReviewsList(reviewsFiltered.reviews);
            else setReviewsList([...reviewsList??[],...reviewsFiltered.reviews])
        }
    }, [reviewsFiltered]);
    
    function formatDate(date?: Date)
    {
        if(!date) return '';
        let stringDate : string = new Intl.DateTimeFormat('en-US', {month:'numeric',day:'numeric',year:'numeric'}).format(new Date(date));
        return stringDate.replace('.','');
    }
    
    return (
        <>
        <S.Root>
            {(!reviewsList || reviewsList?.length===0) && 
            <S.EmptyState>
                {reviewsList?.length===0 ? `There are no results matching that criteria`: ``}
            </S.EmptyState>}
            {reviewsList?.map( (review: Review) => 
            <S.Review>
                <S.GeneralInformation>
                    <S.Label style={{color: props.bodyColor}} >{review.reviewer??'No raiting available'}</S.Label>
                    <S.Label style={{color: props.bodyColor}} >{review.date && formatDate(review.date)}</S.Label>
                    <S.LabelProvider onClick={() => { window.open(review.url, "_blank");}}>
                        {`via ${review.provider??''}`}
                    </S.LabelProvider>
                </S.GeneralInformation>
                <S.ReviewInformation>
                    <S.StarsContainer>
                    {getRatingRecommended({
                        provider: review.provider,
                        recommended: review.recommended,
                        rating: review.rating,
                        starStyle: {width:'17px', height: '17px'},
                        starColor: props.starColor
                    })}
                    </S.StarsContainer>
                    <S.ReviewTitle style={{color: props.bodyColor}} >{review.header??''}</S.ReviewTitle>
                    <S.ReviewText style={{color: props.bodyColor}} >{review.detail??''}</S.ReviewText>
                </S.ReviewInformation>
            </S.Review>)}
        </S.Root>
        {reviewsList && reviewsList.length>0 &&
        <S.Counter>
            {`Showing ${reviewsList?.length.toLocaleString('en-US')} of ${reviewsFiltered?.total?.toLocaleString('en-US')}`}
        </S.Counter>}
        </>
    )
}

export default List;
